import {ActionList, Label} from '@primer/react'

import {useEnvironmentSetupLoader} from './use-environment-setup-loader'

export function EnvironmentSetupLoaderMenuItem() {
  const {cubeEnabled, setCubeEnabled} = useEnvironmentSetupLoader()
  if (!setCubeEnabled) return null

  return (
    <ActionList.Group selectionVariant="multiple">
      <ActionList.Item selected={cubeEnabled} onSelect={() => setCubeEnabled(!cubeEnabled)}>
        ASCII cube while loading
        <ActionList.TrailingVisual>
          <Label variant="attention">Staff</Label>
        </ActionList.TrailingVisual>
      </ActionList.Item>
    </ActionList.Group>
  )
}
